import React, { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'

import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Checkbox from '@material-ui/core/Checkbox'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

import ApplicationHeader from '../ApplicationHeader'

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(0, 2),
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'center',
  },
  backButtonContainer: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    marginTop: theme.spacing(6),
  },
  backButton: {
    color: '#ffffff',
    textDecoration: 'underline',
  },
})
const useStyles = makeStyles(styles)

export default function GreetingsMentorScreen() {
  const classes = useStyles()

  const [acceptsTermsOfUse, setAcceptsTermsOfUse] = useState(false)

  return (
    <Grid className={classes.root} container>
      <Grid item xs={12}>
        <ApplicationHeader />
      </Grid>

      <Grid item xs={12}>
        <Grid container justify="center" spacing={2}>
          <Grid item xs={12} sm={8} lg={4}>
            <Card>
              <CardContent>
                <Typography
                  align="justify"
                  gutterBottom
                  paragraph
                  variant="body2"
                >
                  Olá, ficamos muito felizes com seu interesse em ser mentor do{' '}
                  <b>Nasa Space Apps COVID-19 Challenge</b>, edição especial
                  para criar soluções para o COVID-19.
                </Typography>

                <Typography
                  align="justify"
                  gutterBottom
                  paragraph
                  variant="body2"
                >
                  <b>
                    Antes de se inscrever gostaríamos que estivesse atento às
                    orientações abaixo:
                  </b>
                </Typography>

                <ol>
                  <Typography align="justify" component="li" variant="body2">
                    Este hackathon irá acontecer nos dias 30 e 31 de maio
                    (sábado e domingo);
                  </Typography>
                  <Typography align="justify" component="li" variant="body2">
                    Você precisará estar disponível para mentorias pelo menos 6h
                    no sábado e 5h no domingo;
                  </Typography>
                  <Typography align="justify" component="li" variant="body2">
                    As mentorias irão ocorrer dentro do período das 8h às 22h;
                  </Typography>
                </ol>

                <Typography
                  align="justify"
                  variant="body2"
                  gutterBottom
                  paragraph
                >
                  Está preparado(a)?
                </Typography>

                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={acceptsTermsOfUse}
                        color="primary"
                        onChange={(event) =>
                          setAcceptsTermsOfUse(event.target.checked)
                        }
                        value="accepts_terms_of_use"
                      />
                    }
                    label={
                      <Typography align="justify" variant="body2">
                        Sim. Estou ciente e estarei disponível para ser mentor
                        desse hackathon.
                      </Typography>
                    }
                  />
                </FormControl>
              </CardContent>

              <CardActions className={classes.cardActions}>
                <Button
                  color="primary"
                  component={RouterLink}
                  disabled={!acceptsTermsOfUse}
                  to="/registration/mentor"
                  variant="contained"
                >
                  Começar
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Grid>

      <Grid className={classes.backButtonContainer} item xs={12}>
        <Link
          className={classes.backButton}
          color="primary"
          href="https://spaceappsbrasil.com/"
        >
          Voltar para o site
        </Link>
      </Grid>
    </Grid>
  )
}
